<template lang="pug">
el-card(:body-style='{ padding: "0px" }' v-loading="status !== 'Em processamento' && buscando")
    #operacao-cda-wa-resumo(v-if="status !== 'Em processamento'")
        .operacao-cda-wa-resumo__coluna
            .operacao-cda-wa-resumo__informacao
                p Volume
                p Total

            .operacao-cda-wa-resumo__informacao
                p Volume inserido
                p {{ resumo.volumeInserido || 0,0 }}

            .operacao-cda-wa-resumo__informacao
                p Volume conforme
                p {{ resumo.volumeConforme || 0,0 }}

            .operacao-cda-wa-resumo__informacao
                p Volume com alertas
                p.vermelho {{ resumo.volumeComAlertas || 0,0 }}

            .operacao-cda-wa-resumo__informacao
                p Volume com restrições
                p.vermelho {{ resumo.volumeComRestricoes || 0,0 }}

        .operacao-cda-wa-resumo__coluna
            .operacao-cda-wa-resumo__informacao
                p Imóveis
                p Total

            .operacao-cda-wa-resumo__informacao
                p Imóveis inseridos
                p {{ resumo.imoveisInserido || 0 }}

            .operacao-cda-wa-resumo__informacao
                p
                    i.flow.flow-verified
                    | Imóveis conformes
                p {{ resumo.imoveisConformes || 0 }}

            .operacao-cda-wa-resumo__informacao
                p
                    i.flow.flow-warning-sign.laranja
                    | Imóveis com alertas
                p {{ resumo.imoveisComAlertas || 0 }}

            .operacao-cda-wa-resumo__informacao
                p
                    i.flow.flow-warning-sign
                    | Imóveis com restrições
                p {{ resumo.imoveisComRestricoes || 0 }}

    #operacao-cda-wa-resumo(v-else)
        span.aviso-em-processamento Operação em processamento, por favor aguarde.
</template>

<script>
export default {
    name: 'VisualizarOperacaoCdaWaResumo',

    props: {
        resumo: {
            type: Object,
            required: true
        },
        buscando: {
            type: Boolean,
            required: true
        },
        status: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss">
#operacao-cda-wa-resumo {
    display: flex;

    .operacao-cda-wa-resumo__coluna {
        flex: 1;
        &:first-of-type {
            border-right: 1px solid grey;
        }

        .operacao-cda-wa-resumo__informacao {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 20px;
            
            .vermelho {
                color: red
            }

            .laranja {
                color: orange !important;
            }

            .flow {
                margin-right: 4px;
            }

            .flow-verified {
                color: green;
            }

            .flow-warning-sign {
                color: red;
            }

            p {
                margin: 0;
            }

            &:first-child {
                background-color: white !important;
                border-bottom: 1px solid grey;
                font-weight: bold;
            }

            &:nth-child(odd) {
                background-color: #f0f0f0;
            }
        }
    }

    span.aviso-em-processamento {
        margin: 20px auto;
    }
}
</style>
